// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Enums
import {
  RegattaMessageType,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputDoubleButton,
  InputFile,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  regattaMessageTypeLabel,
} from 'common.language';
import config from '../../../config';

// Types
type $Props = $Translate & {
  item: $Model<'RegattaMessage'> | $ModelUpsertParams<'RegattaMessage'>;
};

const RegattaMessageFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col sm={4}>
          <InputDoubleButton
            className={'mb-3'}
            label={t('Visibility')}
            labelFalse={t('Hidden')}
            labelTrue={t('Visible')}
            name={'Public'}
            value={item.Public}
          />
        </Col>
        <Col
          sm={8}
          xs={12}
        >
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Content')}
            name={'Content'}
            required
            type={'textarea'}
            value={item.Content}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Type')}
            name={'Type'}
            required
            type={'select'}
            value={item.Type}
          >
            {_.map(
              RegattaMessageType,
              (i) => (
                <option
                  key={i}
                  value={i}
                >
                  {t(regattaMessageTypeLabel[i])}
                </option>
              ),
            )}
          </AvField>
        </Col>
        <Col>
          <InputFile
            fileDirUrl={`${config.CDN_URL}/files`}
            label={t('Attachment')}
            labelChangeFile={t('Change file')}
            labelError={t('Error')}
            labelFile={t('File')}
            name={'File'}
            onError={ErrorLog.exception}
            uploadUrl={`${config.CDN_URL}/v1.0/upload/file`}
            value={item.File}
          />
        </Col>
      </Row>
    </>
  );
};

export default RegattaMessageFieldsView;
